export default __webpack_public_path__ + "static/media/RCDashboardEmptyState.f1b7187e.svg";